@if (!inDialog && !childComponent) {
  <p-card class="flex grow flex-col overflow-y-auto">
    <ng-template #header>
      @if (titleTemplate) {
        <ng-template [ngTemplateOutlet]="titleTemplate"></ng-template>
      } @else {
        <div class="p-card-title text-2xl font-bold">{{ title }}</div>
      }
    </ng-template>
    @if (subTitleTemplate) {
      <ng-template [ngTemplateOutlet]="subTitleTemplate"></ng-template>
    }
    <div class="flex grow flex-col">
      <ng-container *ngTemplateOutlet="form" />
    </div>
    <ng-template pTemplate="footer">
      @if (footerTemplate) {
        <ng-template [ngTemplateOutlet]="footerTemplate"></ng-template>
      } @else {
        <ng-template [ngTemplateOutlet]="buttons"></ng-template>
      }
    </ng-template>
  </p-card>
} @else {
  <ng-container *ngTemplateOutlet="form" />
  <br />
  @if (footerTemplate) {
    <ng-template [ngTemplateOutlet]="footerTemplate"></ng-template>
  } @else {
    <ng-template [ngTemplateOutlet]="buttons"></ng-template>
  }
}

<ng-template #form>
  <form [formGroup]="formGroup" class="flex grow flex-col overflow-y-auto" [id]="id + '-' + title">
    <ng-content></ng-content>
  </form>
</ng-template>

<ng-template #buttons>
  @if (apiError || formGroup?.invalid) {
    <div class="flex flex-row grow justify-center w-full">
      <s-form-error-total
        [id]="id + '-' + title"
        [apiError]="apiError"
        [schema]="schema"
        [form]="formGroup"
      ></s-form-error-total>
    </div>
    <br />
  }
  <div class="flex flex-row justify-around w-full pt-0" style="height: 40px">
    @if (showBack) {
      <div class="pt-0 flex items-center justify-center">
        <p-button
          [class.floating-button]="!inDialog && disableFloating !== true"
          [disabled]="(blockBack$ | async) ?? false"
          (onClick)="priorEvent($event)"
          >{{ (backLabel$ | async) ?? backLabel }}</p-button
        >
      </div>
    }
    @if (showSave) {
      <div class="pt-0 flex items-center justify-center">
        <p-button
          [class.floating-button]="!inDialog && disableFloating !== true"
          [disabled]="((submitting$ | async) || (blockSave$ | async)) ?? false"
          (onClick)="onSave($event)"
          >{{ (saveLabel$ | async) ?? saveLabel }}</p-button
        >
      </div>
    }
    @if (showNext) {
      <div class="pt-0 flex items-center justify-center">
        <p-button
          [class.floating-button]="!inDialog && disableFloating !== true"
          [disabled]="(blockNext$ | async) ?? false"
          (onClick)="nextEvent($event)"
          >{{ (nextLabel$ | async) ?? nextLabel }}</p-button
        >
      </div>
    }
  </div>
</ng-template>
